import React, { useCallback, useEffect, useState, useRef, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
const typingPhrases = ['Generate an image', 'Write an email', 'Plan a meal', 'Write a blog post', 'Edit a photo'];
interface SearchBarProps {
  placeholder?: string;
  defaultValue?: string;
  size?: 'large' | 'medium';
}
export function SearchBar({
  placeholder = 'What do you need to get done?',
  defaultValue = '',
  size = 'large'
}: SearchBarProps) {
  const [query, setQuery] = useState(defaultValue);
  const [displayText, setDisplayText] = useState('');
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement>(null);
  const isAnimating = query === '' && !isFocused;
  useEffect(() => {
    if (!isAnimating) return;
    const currentPhrase = typingPhrases[phraseIndex];
    let timeout: ReturnType<typeof setTimeout>;
    if (!isDeleting) {
      if (charIndex < currentPhrase.length) {
        timeout = setTimeout(() => {
          setDisplayText(currentPhrase.slice(0, charIndex + 1));
          setCharIndex(charIndex + 1);
        }, 60 + Math.random() * 40);
      } else {
        timeout = setTimeout(() => {
          setIsDeleting(true);
        }, 2000);
      }
    } else {
      if (charIndex > 0) {
        timeout = setTimeout(() => {
          setDisplayText(currentPhrase.slice(0, charIndex - 1));
          setCharIndex(charIndex - 1);
        }, 30);
      } else {
        setIsDeleting(false);
        setPhraseIndex(prev => (prev + 1) % typingPhrases.length);
      }
    }
    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, phraseIndex, isAnimating]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query.trim())}`);
    }
  };
  return <form onSubmit={handleSubmit} className="w-full" data-id="element-66">
      <div className={`relative w-full ${size === 'large' ? 'max-w-3xl mx-auto' : ''}`} data-id="element-67">
        <SearchIcon className={`absolute left-6 top-1/2 -translate-y-1/2 text-grey-400 ${size === 'large' ? 'w-6 h-6' : 'w-5 h-5'}`} data-id="element-68" />
        <input ref={inputRef} type="text" value={query} onChange={e => setQuery(e.target.value)} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} placeholder={isAnimating ? '' : placeholder} className={`w-full bg-white border border-grey-300 rounded-md focus:outline-none focus:border-black transition-colors ${size === 'large' ? 'pl-16 pr-6 py-6 text-lg' : 'pl-12 pr-4 py-3 text-base'}`} data-id="element-69" />
        {isAnimating && <div className={`absolute top-1/2 -translate-y-1/2 pointer-events-none flex items-center ${size === 'large' ? 'left-16 text-lg' : 'left-12 text-base'}`} data-id="element-70">
            <span className="text-grey-400" data-id="element-71">{displayText}</span>
            <span className="text-grey-400 animate-pulse ml-[1px]" data-id="element-72">|</span>
          </div>}
      </div>
    </form>;
}